/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Backup_SaveInputs */



/**
* | output |
* | --- |
* | "Automatic Backup & Save" |
*
* @param {Automatic_Backup_SaveInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_backup_save = /** @type {((inputs?: Automatic_Backup_SaveInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Backup_SaveInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sauvegarde automatique et enregistrement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Sicherung und Speicherung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Backup e salvataggio automatici")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматическое резервное копирование и сохранение")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copia de seguridad y guardado automáticos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动备份和保存")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動バックアップと保存")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वचालित बैकअप और सेव")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Backup e salvamento automáticos")
	return /** @type {LocalizedString} */ ("Automatic Backup & Save")
});